import { useState, useCallback } from 'react';
import { AppliedFilter, FilterHistory } from './types';

export const useFilterHistory = () => {
    const [history, setHistory] = useState<FilterHistory[]>([
        { filters: [], timestamp: Date.now() }
    ]);
    const [index, setIndex] = useState(0);

    const push = useCallback((filters: AppliedFilter[]) => {
        setHistory(prev => {
            const newHistory = prev.slice(0, index + 1);
            newHistory.push({ filters: [...filters], timestamp: Date.now() });
            setIndex(newHistory.length - 1);
            return newHistory;
        });
        setIndex(prev => prev + 1);
    }, [index]);

    const undo = useCallback(() => {
        setIndex(prev => Math.max(0, prev - 1));
    }, []);

    const redo = useCallback(() => {
        setIndex(prev => Math.min(history.length - 1, prev + 1));
    }, [history.length]);

    const reset = useCallback(() => {
        setHistory([{ filters: [], timestamp: Date.now() }]);
        setIndex(0);
    }, []);

    return {
        current: history[index]?.filters || [],
        push,
        undo,
        redo,
        reset,
        canUndo: index > 0,
        canRedo: index < history.length - 1,
        historyLength: history.length,
    };
};
